import "./index.sass";

import React, { useState } from "react";
import {
  createStyles,
  Grid,
  makeStyles,
  withStyles,
  Table,
  TableContainer,
  TableHead,
  TableRow,
  Theme,
  TableCell,
  TableBody,
  Chip,
  FormControl,
} from "@material-ui/core";
import { Paper, Button, TextField } from "@material-ui/core";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { connect } from "react-redux";
import {
  bookingAutoAssign,
  getAssignedUnassignedBooking,
  getCities,
  updateBooking,
  getZone,
  syncBookingtoMapMyIndia,
} from "../../../actions/GenomicsPhaAction";
import { useEffect } from "react";
import { useRef } from "react";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { Link, useHistory } from "react-router-dom";
import { generateBookingFilterUrl } from "../../../../helpers/generateUrl";
import Loader from "../../loader";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 0,
    },
    toolbar: {
      alignItems: "center",
      justifyContent: "flex-end",
      padding: theme.spacing(0, 1),
      ...theme.mixins.toolbar,
    },
    content: {
      width: "80%",
      flexGrow: 21,
    },
    tableContainer: {
      marginTop: "2rem",
      position: "sticky",
      top: "200px",
    },
    formControl: {
      width: "100%",
    },
  })
);

const StyledTableCell:any = withStyles((theme: Theme) =>
  createStyles({
    head: {
      backgroundColor: "#924A91",
      color: theme.palette.common.white,
      fontSize: "14px",
    },
    body: {
      fontSize: 10,
    },
  })
)(TableCell);

const StyledTableRow:any = withStyles((theme: Theme) =>
  createStyles({
    root: {
      "&:nth-of-type(odd)": {
        backgroundColor: theme.palette.action.hover,
      },
    },
  })
)(TableRow);

interface Props {
  getAssignedUnassignedBooking: any;
  allBookings: any;
  getCities: any;
  cities: any;
  updateBooking: any;
  getZone: any;
  zoneList: any;
  bookingAutoAssign: any;
  loading: any;
  syncBookingtoMapMyIndia: any;
}

const getItemStyle = (isDragging: any, draggableStyle: any, status: any) => {
  return {
    userSelect: "none",
    padding: 1,
    margin: `5px`,
    maxWidth: "200px",
    background: isDragging
      ? "violet"
      : status === "NA"
        ? "white"
        : status === "hold"
          ? "lightyellow"
          : status === "pending"
            ? "cyan"
            : status === "confirmed"
              ? "greenyellow"
              : status === "cancelled"
                ? "pink"
                : status === "bookingcancelled"
                  ? "red"
                  : "lightyellow",
    ...draggableStyle,
  };
};

const getListStyle = (isDraggingOver: any) => ({
  padding: 1,
  minWidth: "200px",
});

const BookingCard: React.FC<Props> = ({
  getAssignedUnassignedBooking,
  allBookings,
  getCities,
  cities,
  updateBooking,
  getZone,
  zoneList,
  bookingAutoAssign,
  loading,
  syncBookingtoMapMyIndia,
}) => {
  const classes = useStyles();

  const history = useHistory();

  useEffect(() => {
    getCities();
    getZone();
    return () => {
      getAssignedUnassignedBooking("", true);
    };
  }, []);

  const [city, setCity] = useState(0);
  const [collection_date, setCollection_date] = useState("");

  const [bookings, setBookings] = useState<any>([]);
  const [phlebos, setPhlebos] = useState<any>([]);
  const [zoneName, setZoneName] = useState<string>("none");
  const timer = useRef<any>(0);

  useEffect(() => {
    let tempBookings: any = [];
    let tempPhlebos: any = [];
    Object.keys(allBookings).map((el: any) => {
      if (el !== "phlebos") {
        tempBookings.push(allBookings[el]);
      } else {
        tempPhlebos.push(...allBookings[el]);
      }
    });
    setBookings(tempBookings.filter((item: any) => item !== undefined));
    setPhlebos(tempPhlebos.filter((item: any) => item !== undefined));
  }, [allBookings]);

  const onDragEnd = async (result: any) => {
    const { source, destination, draggableId } = result;

    if (!destination) {
      return;
    }

    const sInd: any = +draggableId;
    const dInd: any = destination.droppableId.split("-")[2];

    if (
      source.droppableId !== destination.droppableId &&
      dInd &&
      dInd !== "unassigned"
    ) {
      const data: any = {
        phlebo: dInd,
        city,
      };
      await updateBooking(data, sInd);
      filterBookings();
    } else if (dInd && dInd === "unassigned") {
      const data: any = {
        remove_phlebo: true,
      };
      await updateBooking(data, sInd);
      filterBookings();
    }
  };

  const filterBookings = () => {
    const body: any = {
      city,
      collection_date,
    };
    const url = generateBookingFilterUrl(body).substring(2);
    getAssignedUnassignedBooking(url);
  };

  const getAutoCompleteZone = (val: string) => {
    getZone(val);
  };

  const autoAssignBooking = async () => {
    const body: any = {
      zone_id: zoneName,
    };
    await bookingAutoAssign(body);
    getAssignedUnassignedBooking("", true);
  };

  const assignBookingtoMapMyIndia = async () => {
    const body: any = {
      zone_id: zoneName,
      assign_by: "mymyindia",
    };
    await bookingAutoAssign(body);
  };

  const syncBookingAssing = async () => {
    await syncBookingtoMapMyIndia();
    getAssignedUnassignedBooking("", true);
  };

  return (
    <main className={classes.content}>
      <div className={classes.toolbar} />
      <h4 style={{ fontWeight: "bold" }}>ASSIGN BOOKING</h4>
      <Grid
        container
        spacing={1}
        direction="row"
        style={{
          marginTop: "20px",
          padding: "10px",
          background: "#f3f3f3",
          borderRadius: 8,
        }}
      >
        <Grid item xs={12} sm={12} md={12}>
          <strong>Booking Auto Assign to Phlebo</strong>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <FormControl variant="outlined" className={classes.formControl}>
            <Autocomplete
              id="zone"
              onChange={(event, newValue) => {
                if (newValue) {
                  let obj = JSON.parse(JSON.stringify(newValue, null, " "));
                  setZoneName(obj.id);
                }
              }}
              defaultValue={
                zoneList?.results &&
                zoneList?.results.find((code: any) => {
                  return code.id === zoneName;
                })
              }
              options={zoneList?.results || []}
              freeSolo
              blurOnSelect
              getOptionLabel={(option: any) =>
                `${option.id}, ${option?.city?.name}`
              }
              onInputChange={(event, newInputValue) => {
                clearTimeout(timer.current);
                timer.current = setTimeout(() => {
                  getAutoCompleteZone(newInputValue.split(",")[0]);
                }, 1000);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder="Zone"
                  variant="outlined"
                  fullWidth
                  required
                />
              )}
            />
          </FormControl>
        </Grid>
        {/* <Grid item xs={6} sm={4} md={2}>
          <Button
            variant="contained"
            color="secondary"
            style={{ height: "56px" }}
            fullWidth
            onClick={() =>  autoAssignBooking()}
            disabled={zoneName === ""}
          >
            Auto Assign
          </Button>
        </Grid> */}
        {/* <Grid item xs={6} sm={4} md={3}>
          <Button
            variant="contained"
            color="primary"
            style={{ height: "56px" }}
            fullWidth
            onClick={() => assignBookingtoMapMyIndia()}
            disabled={zoneName === ""}
          >
            Booking Assign to MMI
          </Button>
        </Grid> */}
        {/* <Grid item xs={6} sm={4} md={3}>
          <Button
            variant="contained"
            color="primary"
            style={{ height: "56px" }}
            fullWidth
            onClick={() => syncBookingAssing()}
          >
            Booking Sync From MMI
          </Button>
        </Grid> */}
        <Grid item xs={12} sm={6} md={3}>
          <Link
            to="/dashboard/gpha/view-booking-on-map/"
            style={{ textDecoration: "none" }}
          >
            <Button
              variant="contained"
              color="primary"
              style={{ height: "56px" }}
              fullWidth
            >
              View Booking On Map
            </Button>
          </Link>
        </Grid>
      </Grid>

      <Grid
        container
        spacing={1}
        direction="row"
        style={{
          marginTop: "20px",
          padding: "10px",
          background: "#f3f3f3",
          borderRadius: 8,
        }}
      >
        <Grid item xs={12} sm={12} md={12}>
          <strong>Filter</strong>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Autocomplete
            id="city"
            onChange={(event, newValue) => {
              if (newValue) {
                let obj = JSON.parse(JSON.stringify(newValue, null, " "));
                setCity(obj.id);
              }
            }}
            options={cities || []}
            freeSolo
            blurOnSelect
            aria-required
            getOptionLabel={(option: any) => option.name}
            onInputChange={(event, newInputValue) => {
              clearTimeout(timer.current);
              timer.current = setTimeout(() => {
                getCities(newInputValue);
              }, 1000);
              if (newInputValue.length === 0) {
                setCity(0);
              }
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="City *"
                variant="outlined"
                style={{ width: "100%", margin: "0", padding: "0" }}
              />
            )}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <TextField
            name="collection_date"
            type="date"
            value={collection_date}
            className="input"
            label="Collection Date *"
            variant="outlined"
            onChange={(e) => setCollection_date(e.target.value as string)}
            style={{ width: "100%" }}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Button
            variant="contained"
            color="secondary"
            style={{ height: "56px" }}
            fullWidth
            onClick={filterBookings}
            disabled={collection_date === "" || city === 0}
          >
            Filter
          </Button>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Button
            variant="contained"
            color="primary"
            style={{ height: "56px" }}
            fullWidth
            onClick={() => history.push("/dashboard/gpha/bookingCard")}
            disabled={collection_date === "" && city === 0}
          >
            Reset
          </Button>
        </Grid>
      </Grid>
      <TableContainer
        className={classes.tableContainer}
        component={Paper}
        style={{ maxHeight: "600px" }}
      >
        {loading ? (
          <Loader />
        ) : (
          <Table stickyHeader aria-label="simple table">
            <TableHead>
              <StyledTableRow>
                <React.Fragment>
                  {bookings && bookings.length > 0 && (
                    <React.Fragment>
                      <StyledTableCell align="center">
                        Time slot
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        Unassigned Bookings
                      </StyledTableCell>
                    </React.Fragment>
                  )}
                  {phlebos &&
                    phlebos.length > 0 &&
                    phlebos.map((item: any) => {
                      return (
                        <StyledTableCell key={item.id} align="center">
                          {item.user && item.user.username}
                        </StyledTableCell>
                      );
                    })}
                </React.Fragment>
              </StyledTableRow>
            </TableHead>
            <TableBody>
              {bookings &&
                bookings.map((el: any, ind: any) => (
                  <React.Fragment key={ind}>
                    <StyledTableRow>
                      <React.Fragment>
                        <StyledTableCell
                          align="center"
                          style={{ minWidth: "150px" }}
                        >
                          <Button
                            variant="text"
                            style={{
                              color: "black",
                            }}
                          >
                            {el.slot.split("-")[0]}
                            <br />
                            {" to "}
                            <br />
                            {el.slot.split("-")[1]}
                            {/* {moment(`${el.slot.split("-")[0]}`, ["HH.mm.ss"]).format("hh:mm A")}
                                                    <br />
                                                    {" to "}
                                                    <br />
                                                    {moment(`${el.slot.split("-")[1]}`, ["HH.mm.ss"]).format("hh:mm A")} */}
                          </Button>
                        </StyledTableCell>
                        <DragDropContext onDragEnd={onDragEnd}>
                          <Droppable
                            key={ind}
                            droppableId={`${el.slot}-unassigned`}
                          >
                            {(provided, snapshot) => (
                              <StyledTableCell
                                align="center"
                                ref={provided.innerRef}
                                style={getListStyle(snapshot.isDraggingOver)}
                                {...provided.droppableProps}
                              >
                                {el &&
                                  el.unassigned &&
                                  el.unassigned.map((item: any, index: any) => {
                                    let packages: any = [];
                                    item.packages &&
                                      item.packages.map(
                                        (pack: any, index: any) => {
                                          return packages.push(pack.name);
                                        }
                                      );
                                    return (
                                      <Draggable
                                        key={item.pk}
                                        draggableId={`${item.pk}`}
                                        index={index}
                                      >
                                        {(provided, snapshot) => (
                                          <Paper
                                            elevation={5}
                                            ref={provided.innerRef}
                                            {...provided.draggableProps}
                                            {...provided.dragHandleProps}
                                            style={getItemStyle(
                                              snapshot.isDragging,
                                              provided.draggableProps.style,
                                              item.booking_status ===
                                                "cancelled"
                                                ? "bookingcancelled"
                                                : "NA"
                                            )}
                                          >
                                            <div
                                              className="card"
                                              style={{
                                                display: "flex",
                                                flexDirection: "column",
                                                // justifyContent: "space-around",
                                              }}
                                            >
                                              <div>
                                                <Chip
                                                  label={`Booking Id: ${item.pk}`}
                                                  color="secondary"
                                                  onClick={() =>
                                                    history.push(
                                                      `/dashboard/gpha/booking-view/${item.pk}`
                                                    )
                                                  }
                                                  style={{
                                                    width: "100%",
                                                    fontSize: "10px",
                                                    background:
                                                      !snapshot.isDragging
                                                        ? "black"
                                                        : "purple",
                                                  }}
                                                // style={{
                                                //     color: !snapshot.isDragging ? "black" : "purple",
                                                //     border: `2px solid ${!snapshot.isDragging ? "black" : "purple"}`
                                                // }}
                                                />
                                              </div>
                                              {/* <p>
                                                                                        <b>Packages: </b>{packages.join(", ").length > 30 ? `${packages.join(", ").substring(0, 30)}...` : packages.join(", ")}
                                                                                    </p> */}
                                              <div
                                                className="cards"
                                                style={{
                                                  backgroundColor:
                                                    item.verification_status ===
                                                      "pending"
                                                      ? "#fbc02d"
                                                      : item.phlebo_reached
                                                        ? "#7e57c2"
                                                        : "",
                                                }}
                                              >
                                                <div className="card_child">
                                                  <b>C_Name: </b>
                                                  <span className="spans">
                                                    {item.customer_name &&
                                                      item.customer_name}{" "}
                                                  </span>
                                                </div>
                                                <div className="card_child">
                                                  <b>Amount: </b>{" "}
                                                  <span className="spans">
                                                    &#8377;
                                                    {item.discounted_price &&
                                                      item.discounted_price
                                                        .final_total_price}
                                                  </span>
                                                </div>
                                                <div className="card_child">
                                                  <b>Address: </b>{" "}
                                                  <span className="spans">
                                                    {item?.booking_full_address}
                                                  </span>
                                                </div>
                                              </div>
                                              {/* <p>
                                                                                        <b>Amount: </b>&#8377;{item.discounted_price && item.discounted_price.final_total_price}<br/>
                                                                                    </p>
                                                                                    <p>
                                                                                        <b>Address: </b>{item.customer_address}
                                                                                    </p> */}
                                              {/* <Button
                                                                                        variant="text"
                                                                                        color="default"
                                                                                        fullWidth
                                                                                        onClick={() => history.push(`/dashboard/gpha/booking-view/${item.pk}`)}
                                                                                        style={{
                                                                                            color: !snapshot.isDragging ? "black" : "purple",
                                                                                            border: `2px solid ${!snapshot.isDragging ? "black" : "purple"}`
                                                                                        }}
                                                                                    >
                                                                                        View Booking
                                                                                    </Button> */}
                                            </div>
                                          </Paper>
                                        )}
                                      </Draggable>
                                    );
                                  })}
                                {provided.placeholder}
                              </StyledTableCell>
                            )}
                          </Droppable>
                          {phlebos &&
                            phlebos.length > 0 &&
                            phlebos.map((phleb: any, index: any) => {
                              return (
                                <Droppable
                                  key={index}
                                  droppableId={`${el.slot}-${phleb.id}`}
                                >
                                  {(provided, snapshot) => (
                                    <StyledTableCell
                                      align="center"
                                      ref={provided.innerRef}
                                      style={getListStyle(
                                        snapshot.isDraggingOver
                                      )}
                                      {...provided.droppableProps}
                                    >
                                      {el &&
                                        el.assigned &&
                                        el.assigned.map(
                                          (item: any, index: any) => {
                                            let packages: any = [];
                                            item.packages &&
                                              item.packages.map(
                                                (pack: any, index: any) => {
                                                  return packages.push(
                                                    pack.name
                                                  );
                                                }
                                              );
                                            if (
                                              phleb.user.username ===
                                              item.phlebo.name
                                            ) {
                                              return (
                                                <Draggable
                                                  key={item.pk}
                                                  draggableId={`${item.pk}`}
                                                  index={index}
                                                >
                                                  {(provided, snapshot) => (
                                                    <Paper
                                                      elevation={5}
                                                      ref={provided.innerRef}
                                                      {...provided.draggableProps}
                                                      {...provided.dragHandleProps}
                                                      style={getItemStyle(
                                                        snapshot.isDragging,
                                                        provided.draggableProps
                                                          .style,
                                                        item.booking_status ===
                                                          "cancelled"
                                                          ? "bookingcancelled"
                                                          : item.pickup_status
                                                      )}
                                                    >
                                                      <div
                                                        className="card"
                                                        style={{
                                                          display: "flex",
                                                          flexDirection:
                                                            "column",
                                                          // justifyContent: "space-around",
                                                        }}
                                                      >
                                                        <div>
                                                          <Chip
                                                            label={`Booking Id: ${item.pk}`}
                                                            onClick={() =>
                                                              history.push(
                                                                `/dashboard/gpha/booking-view/${item.pk}`
                                                              )
                                                            }
                                                            color="secondary"
                                                            style={{
                                                              width: "100%",
                                                              background:
                                                                snapshot.isDragging
                                                                  ? "purple"
                                                                  : item.pickup_status ===
                                                                    "hold"
                                                                    ? "brown"
                                                                    : item.pickup_status ===
                                                                      "pending"
                                                                      ? "#3f51b5"
                                                                      : item.pickup_status ===
                                                                        "confirmed"
                                                                        ? "green"
                                                                        : item.pickup_status ===
                                                                          "cancelled"
                                                                          ? "#f50057"
                                                                          : "white",
                                                            }}
                                                          />
                                                        </div>
                                                        {/* <p>
                                                                                                    <b>Packages: </b>{packages.join(", ").length > 30 ? `${packages.join(", ").substring(0, 30)}...` : packages.join(", ")}
                                                                                                </p> */}
                                                        <div className="cards">
                                                          <div className="card_child">
                                                            <b>C_Name: </b>
                                                            <span className="spans">
                                                              {item.customer_name &&
                                                                item.customer_name}
                                                            </span>
                                                          </div>
                                                          <div className="card_child">
                                                            <b>Amount: </b>{" "}
                                                            <span className="spans">
                                                              &#8377;
                                                              {item.discounted_price &&
                                                                item
                                                                  .discounted_price
                                                                  .final_total_price}
                                                            </span>
                                                          </div>
                                                          <div className="card_child">
                                                            <b>Address: </b>{" "}
                                                            <span className="spans">
                                                              {
                                                                item?.booking_full_address
                                                              }
                                                            </span>
                                                          </div>
                                                        </div>
                                                        {/* <div className="cards">
                                                                                                    <b>Customer Name: </b>{item.customer_name && item.customer_name}<br/>
                                                                                                    <b>Amount: </b>&#8377;{item.discounted_price && item.discounted_price.final_total_price}<br/>
                                                                                                     <b>Address: </b>{item.customer_address}
                                                                                                </div> */}
                                                        {/* <p>
                                                                                                    <b>Amount: </b>&#8377;{item.discounted_price && item.discounted_price.final_total_price}
                                                                                                </p>
                                                                                                <p>
                                                                                                    <b>Address: </b>{item.customer_address}
                                                                                                </p> */}
                                                        {/* <Button
                                                                                                    variant="outlined"
                                                                                                    color="default"
                                                                                                    fullWidth
                                                                                                    onClick={() => history.push(`/dashboard/gpha/booking-view/${item.pk}`)}
                                                                                                    style={{
                                                                                                        color: snapshot.isDragging ? "purple" : item.booking_status === "cancelled" ? "black" : item.pickup_status === "hold" ? "brown" : item.pickup_status === "pending" ? "#3f51b5" : item.pickup_status === "confirmed" ? "green" : item.pickup_status === "cancelled" ? "#f50057" : "white",
                                                                                                        border: `2px solid ${snapshot.isDragging ? "purple" : item.booking_status === "cancelled" ? "black" : item.pickup_status === "hold" ? "brown" : item.pickup_status === "pending" ? "#3f51b5" : item.pickup_status === "confirmed" ? "green" : item.pickup_status === "cancelled" ? "#f50057" : "white"}`,
                                                                                                    }}
                                                                                                >
                                                                                                    View Booking
                                                                                                </Button> */}
                                                      </div>
                                                    </Paper>
                                                  )}
                                                </Draggable>
                                              );
                                            } else {
                                              return <div key={index}></div>;
                                            }
                                          }
                                        )}
                                      {provided.placeholder}
                                    </StyledTableCell>
                                  )}
                                </Droppable>
                              );
                            })}
                        </DragDropContext>
                      </React.Fragment>
                    </StyledTableRow>
                  </React.Fragment>
                ))}
            </TableBody>
          </Table>
        )}
      </TableContainer>
    </main>
  );
};

const mapStateToProps = (state: any) => ({
  allBookings: state.GenomicsPhaReducer.allBookings,
  cities: state.GenomicsPhaReducer.cities,
  loading: state.GenomicsPhaReducer.loading,
  zoneList: state.GenomicsPhaReducer.zoneList,
});

export default connect(mapStateToProps, {
  getAssignedUnassignedBooking,
  getCities,
  updateBooking,
  getZone,
  bookingAutoAssign,
  syncBookingtoMapMyIndia,
})(BookingCard);
